import { BaseRequest, IBaseRequest } from "../../BaseRequest";

interface JournalFilter {
    name: string;
    code?: string;
}
export interface IListJournalRequest extends IBaseRequest {
    id?: string;
    linkTable?: string;
    linkName?: string;
    treeHandle?: string;
    orderBy?: string;
    orderByType?: string;
    countOnly?: boolean;
    offset?: number;
    limit?: number;
    FILTER?: JournalFilter;
    type?: string;
}

export class ListJournalRequest
    extends BaseRequest
    implements IListJournalRequest
{
    public id?: string;
    public linkTable?: string;
    public linkName?: string;
    public treeHandle?: string;
    public orderBy?: string;
    public orderByType?: string;
    public countOnly?: boolean;
    public offset?: number;
    public limit?: number;
    public FILTER?: JournalFilter;
    public type?: string;

    constructor(server: string, session: string, otherOptions?: any) {
        super(server, session);
        this.id = otherOptions?.id;
        this.linkTable = otherOptions?.linkTable;
        this.linkName = otherOptions?.linkName;
        this.treeHandle = otherOptions?.treeHandle;
        this.orderBy = otherOptions?.orderBy;
        this.orderByType = otherOptions?.orderByType;
        this.countOnly = otherOptions?.countOnly;
        this.offset = otherOptions?.offset;
        this.limit = otherOptions?.limit;
        this.FILTER = otherOptions?.FILTER;
        this.type = otherOptions?.type;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.id, "id");
        parameters += this.makeNode(this.linkTable, "linkTable");
        parameters += this.makeNode(this.linkName, "linkName");
        parameters += this.makeNode(this.treeHandle, "treeHandle");
        parameters += this.makeNode(this.orderBy, "orderBy");
        parameters += this.makeNode(this.orderByType, "orderByType");
        parameters += this.makeNode(this.countOnly, "countOnly");
        parameters += this.makeNode(this.offset, "offset");
        parameters += this.makeNode(this.limit, "limit");
        if (this.FILTER) {
            parameters += "<FILTER>";
            parameters += this.makeNode(this.FILTER.name, "name");
            parameters += this.makeNode(this.FILTER.code, "code");
            parameters += "</FILTER>";
        }
        parameters += this.makeNode(this.type, "type");
        return super.wrapperXml("ListJournal", parameters);
    }
}
